export default function SelectSetFocusOnDirective($timeout, $parse) {
  'ngInject';

  return {
    require: 'uiSelect',
    restrict: 'A',
    link: function(scope, element, attrs, $select) {
      var model = $parse(attrs.selectSetFocusOn);
      scope.$watch(model, function(currentValue) {
        if (currentValue === true) {
          $timeout(function() {
            $select.setFocus();
          });
        }
      });
      element.bind('blur', function() {
        if (model.assign) {
          // use timeout to avoid [$rootScope:inprog] error
          $timeout(() => scope.$apply(model.assign(scope, false)), 0, false);
        }
      });
    },
  };
}
